import { Typography, Box, useTheme, useMediaQuery } from "@mui/material";
import { tokens } from "../theme";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isSmallScreen = useMediaQuery("(max-width: 700px)"); // Detect small screens

  return (
    <Box mb="30px">
      <Typography
        variant="h2"
        color={colors.grey[100]}
        fontWeight="bold"
        sx={{ 
          m: "0 0 5px 0", 
          fontSize: isSmallScreen ? "24px" : "32px",
          marginTop:isSmallScreen ? "45px" : "0px", // ✅ Responsive font size
        }}
      >
        {title}
      </Typography>
      <Typography 
        variant="h5" 
        color={colors.greenAccent[400]}
        sx={{ fontSize: isSmallScreen ? "16px" : "20px" }} // ✅ Adjust subtitle size
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
